import { Axios, AxiosError, AxiosResponse } from 'axios';
import { GetRecipeResponse, ImportRecipeRequest, ImportRecipeResponse, PostRecipeResponse, ProcessUploadRequest, ProcessUploadResponse, PutRecipeResponse, Recipe, RecipeSearchResponse, UploadRecipeResponse } from './models';

export class RecipeServiceProps {
  api!: Axios
}

export interface RecipeSearchParams {
  name?: string;
  offset?: number;
  limit?: number;
  tags?: string[]; // optional: for future filters
  ingredients?: string[]; // optional: for future filters
}

export class RecipeService {
  api!: Axios;

  constructor(props: RecipeServiceProps) {
    this.api = props.api;
  }

  async get(id: string): Promise<AxiosResponse<GetRecipeResponse, AxiosError>> {
    return this.api.get<GetRecipeResponse>(`/recipe/${id}`);
  }

  async put(recipe: Recipe): Promise<AxiosResponse<PutRecipeResponse, AxiosError>> {
    return this.api.put<PutRecipeResponse>(`/recipe/${recipe.id}`, recipe);
  }

  async post(recipe: Recipe): Promise<AxiosResponse<PostRecipeResponse, AxiosError>> {
    return this.api.post<PostRecipeResponse>('/recipe', recipe);
  }

  async delete(id: string): Promise<AxiosResponse<unknown, AxiosError>> {
    return this.api.delete(`/recipe/${id}`);
  }

  async import(request: ImportRecipeRequest): Promise<AxiosResponse<ImportRecipeResponse, AxiosError>> {
    return this.api.post<ImportRecipeResponse>('/recipe/import', request);
  }

  async get_signed_upload(): Promise<AxiosResponse<UploadRecipeResponse, AxiosError>> {
    return this.api.get<UploadRecipeResponse>('/recipe/import/upload');
  }

  async upload(): Promise<AxiosResponse<UploadRecipeResponse, AxiosError>> {
    return this.api.put<UploadRecipeResponse>('/recipe/import/upload');
  }

  async process(request: ProcessUploadRequest): Promise<AxiosResponse<ProcessUploadResponse, AxiosError>> {
    return this.api.post<ProcessUploadResponse>('/recipe/import/process', request);
  }

  async search(params: RecipeSearchParams): Promise<AxiosResponse<RecipeSearchResponse, AxiosError>> {
    return this.api.get<RecipeSearchResponse>('/recipe/search', {
      params: params,
    });
  }
}
